import { useParams } from 'react-router-dom';

const ConfigurationDetail = () => {
  const { id } = useParams();

  return (
    <div>
      <h1 className="text-2xl font-semibold mb-6">Configuration Details</h1>
      <p className="text-gray-500">Configuration ID: {id}</p>
      {/* Configuration details will be implemented later */}
    </div>
  );
};

export default ConfigurationDetail;